import React from "react";

function Footer() {
  return (
    <div className="footer">
      This site is under construction therefore this website will be updated
      constantly.
    </div>
  );
}

export default Footer;
